/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Admin_Recipient_SourceInputs */

const en_mail_admin_recipient_source = /** @type {(inputs: Mail_Admin_Recipient_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please provide either user IDs or a filter.`)
};

const de_mail_admin_recipient_source = /** @type {(inputs: Mail_Admin_Recipient_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie entweder Nutzer-IDs oder einen Filter an.`)
};

/**
* | output |
* | --- |
* | "Please provide either user IDs or a filter." |
*
* @param {Mail_Admin_Recipient_SourceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_admin_recipient_source = /** @type {((inputs?: Mail_Admin_Recipient_SourceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Admin_Recipient_SourceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_admin_recipient_source(inputs)
	return en_mail_admin_recipient_source(inputs)
});